import { Box, Typography } from "@mui/material";
import React from "react";
import whattodo from "../../assets/images/What we do.png";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Orangelogo from "../../assets/images/Orangelogo.png";
import StoryTwoImage from "../../assets/images/StoryImageOne.webp";

const OurStory = () => {
  return (
    <Box
      sx={{
        maxWidth: { xs: "100%", md: "1440px" },
        margin: "0 auto",
        marginTop: "2rem",
        display: "flex",
        flexDirection: { xs: "column-reverse", md: "row" },
        padding: { xs: "0rem 1.8rem", md: "0rem 3rem" },
      }}
    >
      <Box
        sx={{
          width: { xs: "100%", md: "50%" },
        }}
      >
        <Box
          sx={{
            width: { xs: "80%", md: "34rem" },
            margin: { xs: "0rem auto", md: "2rem 0 0" },
          }}
        >
          <LazyLoadImage
            src={StoryTwoImage}
            effect="blur"
            width="100%"
            height="100%"
          />
        </Box>
      </Box>
      <Box
        sx={{
          width: { xs: "100%", md: "50%" },
        }}
      >
        <Box
          sx={{
            width: "4rem",
            marginTop: { xs: "2rem", md: "2rem" },
          }}
        >
          <img src={Orangelogo} alt="" width="100%" />
        </Box>
        <Typography
          sx={{
            color: "rgba(35, 35, 37, 1)",
            fontFamily: "Montserrat",
            fontSize: { xs: "0.8rem", md: "1rem" },
            marginTop: "0.8rem",
          }}
        >
          WHAT WE DO
        </Typography>
        <Typography
          variant="h4"
          sx={{
            fontFamily: "Montserrat",
            fontSize: { xs: "1.4rem", md: "1.6rem" },
            fontWeight: "500",
            marginTop: "1.2rem",
          }}
        >
          The{" "}
          <span style={{ color: "rgba(255, 102, 0, 1)" }}>
            Inteliphyle Touch
          </span>
        </Typography>
        <Typography
          sx={{
            fontFamily: "Montserrat",
            marginTop: "1.2rem",
            marginBottom: "1.2rem",
          }}
        >
          Businesses today are drowning in data but starving for actionable
          marketing advice. While information is abundant, the real challenge
          lies in transforming complexity into clear, strategic decisions -
          that's where Inteliphyle comes in.
        </Typography>
        <Typography
          sx={{
            fontFamily: "Montserrat",
            marginTop: "1.2rem",
            marginBottom: "1.2rem",
          }}
        >
          A data-centric business consulting startup, Inteliphyle excels in
          advisory services combining machine, human and artificial intelligence
          to drive clarity in a complex world. Built on the principles of design
          thinking and tailored solutions, we deliver disruptive strategies that
          empower businesses to navigate change with confidence.
        </Typography>
      </Box>
    </Box>
  );
};

export default OurStory;
